import classNames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';
import { t } from '../../../../../i18n';
import { ArrowRightIconComponent } from '../../../../assets';
import './styles.scss';

const PreviousAndNextLessonsFooter = ({ previousLesson, nextLesson }) => {
  return (
    <div className="courses-watch-lesson__footer">
      {previousLesson && (
        <LessonButton
          text={t('DIGITAL_COURSES.WATCH.PREVIOUS_LESSON')}
          lesson={previousLesson}
          className="courses-watch-lesson__footer__lesson_previous"
        />
      )}
      {nextLesson && (
        <LessonButton
          text={t('DIGITAL_COURSES.WATCH.NEXT_LESSON')}
          lesson={nextLesson}
          className="courses-watch-lesson__footer__lesson_next"
        />
      )}
    </div>
  );
};

export default PreviousAndNextLessonsFooter;

const LessonButton = ({ text, lesson, className }) => (
  <Link className={classNames('courses-watch-lesson__footer__lesson', className)} to={lesson.watchUrl}>
    <div className="courses-watch-lesson__footer__lesson__arrow">
      <ArrowRightIconComponent />
    </div>
    <div>
      <p className="courses-watch-lesson__footer__lesson__title">
        {t('DIGITAL_COURSES.WATCH.LESSON_NUMBER', { number: lesson.lessonNumber })} {lesson.title}
      </p>
      <p className="courses-watch-lesson__footer__lesson__order">{text}</p>
    </div>
  </Link>
);
